// extracted by mini-css-extract-plugin
module.exports = {"melodyVideo":"Yh","landingPageVideo":"Zh","play":"_h","iframeVideo":"ai","playHidden":"bi","playVisible":"ci","fullwidth":"di"};